/**
 * Печать документа — счёта, акта, наряда, прайса.
 *
 * Печатается НЕ ЭКРАН, а сам документ. Обычный `window.print()` отправил бы
 * на бумагу всё окно программы: боковое меню, шапку, кнопки, — и документ
 * пришлось бы вырезать ножницами. Поэтому разметка документа кладётся в
 * отдельную скрытую рамку и печатается она.
 *
 * Так же собирается PDF на сервере: тот же HTML отдаётся headless Chromium.
 * Значит распечатанное с экрана и сохранённое в PDF — один и тот же лист,
 * а не два похожих.
 *
 * Рамка убирается ПОСЛЕ печати, а не сразу: браузер печатает не мгновенно, и
 * удаление рамки в тот же миг отменяло бы задание. Событие `afterprint` даёт
 * точный момент; там, где его нет, остаётся запасной срок.
 */
export function printHtml(html: string): void {
  const рамка = document.createElement('iframe');
  рамка.setAttribute('aria-hidden', 'true');
  рамка.setAttribute('title', 'Печать');
  /*
   * Рамка не `display: none`: скрытую таким образом браузер не печатает
   * вовсе — ей нечего верстать. Поэтому она остаётся в потоке, но нулевого
   * размера и без видимости.
   */
  рамка.style.cssText =
    'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  рамка.srcdoc = html;

  рамка.onload = () => {
    const окно = рамка.contentWindow;
    if (!окно) {
      рамка.remove();
      return;
    }

    let убрано = false;
    const убрать = () => {
      if (убрано) return;
      убрано = true;
      рамка.remove();
    };

    окно.addEventListener('afterprint', убрать);
    // Запасной срок: Safari на телефоне про `afterprint` знает не всегда.
    window.setTimeout(убрать, 60_000);

    окно.focus();
    окно.print();
  };

  document.body.appendChild(рамка);
}
